import { useEffect } from "react";

type Func = () => void;

// eslint-disable-next-line react-hooks/exhaustive-deps
export const useMountEffect = (fn: Func) => useEffect(fn, []);

export default useMountEffect;
